import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/common.css'
import './assets/css/style.css'
import './assets/js/rem'
import Vant from 'vant'
import 'vant/lib/index.css'
import Fly from 'flyio/dist/npm/fly'
import common from "@/assets/js/common"
import Video from 'video.js'
import 'video.js/dist/video-js.css'

Vue.config.productionTip = false
var fly = new Fly
Vue.prototype.$http = fly
Vue.prototype.$common = common
Vue.prototype.$video = Video
Vue.use(Vant)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
